// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__l9V5g","topBottomGutter":"Layout_topBottomGutter__16C4E"};